import Amplify from '@aws-amplify/auth';

export const AWS_REGION=process.env.VUE_APP_AWS_REGION ;
export const AWS_USER_POOL_ID=process.env.VUE_APP_AWS_USER_POOL_ID ;
export const AWS_USER_POOL_WEB_CLIENT_ID=process.env.VUE_APP_AWS_USER_POOL_WEB_CLIENT_ID ;

// window.LOG_LEVEL='DEBUG' // useful for authentication debugging purpose
Amplify.configure({
  Auth: {
    region: AWS_REGION,
    userPoolId: AWS_USER_POOL_ID,
    userPoolWebClientId: AWS_USER_POOL_WEB_CLIENT_ID,
  },
});
